// extracted by mini-css-extract-plugin
export default {"headerImg":"Header_headerImg__M34xh","title":"Header_title__umD3S","verReceta":"Header_verReceta__xcS+K","headerDesktop":"Header_headerDesktop__TjECA"};